let styles = {
    container: {
        background: 'white',
        boxShadow: '0 1px 4px rgba(0,0,0,.15)',
        padding: '2px',
        display: 'flex',
        justifyContent: 'center',
    },
    main_header: {
        padding:'0px',
        margin:'10px 0px',
        display:'flex',
    },
    title: {
        padding:'5px',
        textAlign:'center',
        fontSize:'16px'
    },
    row: {
        margin:'1% 0%',
        display:'flex',
        flexDirection:'row',
        overflowX:'auto'
    },
    item: {
        color:'#7d3cff',
    },
    bold_text: {
        fontWeight:'bold',
    }

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/venueDetails/style.js